// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"36cacd26","101":"d2b0ed19","115":"6bdc5252","233":"a3435833","299":"5b0ab1c0","453":"8e424a35","676":"a1b45bf6","708":"1983a46d","852":"d16d0886"}[chunkId] + ".chunk.js";
};